import imageCompression from 'browser-image-compression';

/**
 * Compress image before uploading to Firebase
 * Optimized for conference Wi-Fi scenarios
 */
export const compressImage = async (file, maxSizeMB = 0.5, maxWidthOrHeight = 1920) => {
  const options = {
    maxSizeMB,
    maxWidthOrHeight,
    useWebWorker: true,
    fileType: 'image/jpeg',
    initialQuality: 0.85,
  };

  try {
    const compressedFile = await imageCompression(file, options);
    console.log(`Compressed from ${(file.size / 1024 / 1024).toFixed(2)}MB to ${(compressedFile.size / 1024 / 1024).toFixed(2)}MB`);
    return compressedFile;
  } catch (error) {
    console.error('Image compression error:', error);
    // Return original file if compression fails
    return file;
  }
};

